// Bumped on every deployment. See /app/VERSION.md for the change log.
export const APP_VERSION = 'v1.0.27';
